import { applicationModuleRegistry } from '@philips-emr/tws-foundation';

import { Route } from '../../route';

export function registerDocumentManagement(): void {

  const modules = [
    {
      entry: 'accreditation-update',
      id: 'accreditation-update',
      name: 'provider.accreditation-update',
      route: Route.ACCREDITATION_UPDATE,
      closeable: true,
    },
    {
      entry: 'cnes-search',
      id: 'cnes-search',
      name: 'provider.cnes-search',
      route: Route.CNES_SEARCH,
      closeable: true,
    },
    {
      entry: 'indicators',
      id: 'indicators',
      name: 'provider.indicators',
      route: Route.INDICATORS,
      closeable: true,
    },
    {
      entry: 'negotiation',
      id: 'negotiation',
      name: 'provider.negotiation',
      route: Route.NEGOTIATION,
      closeable: true,
    },
    {
      entry: 'action-plan',
      id: 'action-plan',
      name: 'provider.action-plan',
      route: Route.ACTION_PLAN,
      closeable: true,
    },
    {
      entry: 'tasks',
      id: 'tasks',
      name: 'provider.tasks',
      route: Route.TASKS,
      closeable: true,
    },
    {
      entry: 'technical-visit',
      id: 'technical-visit',
      name: 'provider.technical-visit',
      route: Route.TECHNICAL_VISIT,
      closeable: true,
    },
  ];

  applicationModuleRegistry.registerGroup({
    entry: 'provider-managment',
    id: 'provider-managment',
    name: 'provider.provider-management',
    modules,
    order: 3,
    closeable: true,
  });
}
